import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ArticlePricelistsService, PricelistsType} from "../../data/article-pricelists.service";
import {TranslateService} from "../../../../services/multilingual/translate.service";
import {ArticlePricelist} from "../../data/interfaces/article-pricelist";
import {ProjectsService} from "../../../projects/data/projects.service";
import {JBMTableColumnDef,JBMTableColumnType} from "../../../../components/JBM/JBMTable/JBMTable.component";
import {QueryHttpHelper, SearchColumnType} from "../../../../components/JBM/Helpers/QueryHttpHelper";
import {TokenService} from "../../../../services/auth/token.service";
import {JBMToastsService} from "../../../../components/JBM/Views/JBMToasts/JBMToasts.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'pricelist-assign-projects',
  templateUrl: './pricelist-assign-projects.component.html',
  styleUrls: ['./pricelist-assign-projects.component.scss']
})
export class PricelistAssignProjectsComponent implements OnInit {
  items: any[]=[];
  columnDefs: JBMTableColumnDef[];
  loading: boolean=false;
  language: string=this.TokenService.getLanguage();
  project_ids: number[]=[];
  items$: Subscription;
  count$: Subscription;

  queryHttpHelper: QueryHttpHelper;
  searchboxVisible: boolean=true;
  search: string='';

  types=this.ArticlePricelistsService.getTypeItems(this.TranslateService);
  caption: string;

  constructor(
      private ArticlePricelistsService: ArticlePricelistsService,
      private ProjectsService: ProjectsService,
      private TokenService: TokenService,
      private TranslateService: TranslateService,
      private JBMToastsService: JBMToastsService
  )
  { this.pricelist=this.ArticlePricelistsService.getEmpty() }

  @Input() pricelistsType: PricelistsType=PricelistsType.articles;
  @Input() pricelist: ArticlePricelist;

  @Output() onAssigned=new EventEmitter();
  @Output() onCancel=new EventEmitter();

  @ViewChild('toggleTemplate') toggleTemplate: TemplateRef<any>;

  ngOnInit(): void {
    if(this.pricelistsType===PricelistsType.articles)
      this.caption='financial.article-pricelist';
    else
      this.caption='financial.concrete-pricelist';

    this.columnDefs = [
      { name: 'id', type: JBMTableColumnType.id },
      { name: 'toggle', type: JBMTableColumnType.boolean, iconClassname: 'check', sortable: false, filterable: false, width: 1 },
      { name: 'name', header: this.TranslateService.GetTranslation('entity.name'), sortable: true, filterable: true }
    ];

    this.queryHttpHelper = new QueryHttpHelper();
    this.queryHttpHelper.setSortColumn('name');
    this.queryHttpHelper.addSearchColumn('name', SearchColumnType.string);
    this.queryHttpHelper.paginationProps.pageSize=5;

    this.getData(true);
  }
  getData(countRows:boolean=false) {
    this.loading=true;
    let httpParams=this.queryHttpHelper.getHttpParams(false);
    this.items$=this.ProjectsService.getSelectList(this.language, this.pricelistsType, this.pricelist.id, httpParams).subscribe(
        (data: any) => this.items=data.data,()=>{},()=>{
          this.loading=false;

          // Set toggle template
          this.columnDefs[1].template = this.toggleTemplate;

          if(countRows) {
            let httpParams=this.queryHttpHelper.getHttpParams(true);
            this.count$=this.ProjectsService.getSelectList(this.language, this.pricelistsType, this.pricelist.id, httpParams).subscribe(
                (data: any) => this.queryHttpHelper.paginationProps.itemCount = data.data,()=>{},()=>{} );
          }
        }
    );
  }
  pageChange(page: any) {
    this.queryHttpHelper.paginationProps.page=page;
    this.getData();
  }
  sortChange(event: any) {
    this.queryHttpHelper.setSortColumn(event.name, event.descending);
    this.getData();
  }
  searchChange(event: any) {
    let value=event.value;
    let minlength=event.minlength;
    value=value.length<minlength ? '' : value;
    if(this.queryHttpHelper.getSearchValue() != value) {
      this.queryHttpHelper.setSearchValue(value);
      this.getData(true);
    }
  }
  rowSelect(row: any) {
    this.toggleProject(row.id);
  }
  toggleProject(id:number) {
    let index=this.project_ids.indexOf(id);
    if(index===-1)
      this.project_ids.push(id)
    else
      this.project_ids.splice(index,1);
  }
  assign() {
    this.ProjectsService.assignPricelists({ pricelistsType: this.pricelistsType, pricelist_id: this.pricelist.id,
      project_ids: this.project_ids }).subscribe(
        ()=>{},
        (error: any)=>console.error(error),
        ()=> {
          this.JBMToastsService.success(this.TranslateService.GetTranslation('ui.entities-saved'));
          this.onAssigned.emit();
        }
    )
  }
  cancel() {
    this.onCancel.emit();
  }
}
